<tr *ngFor="let row of data.rows">
  <td
    *ngFor="let cell of row.cells"
    [innerHTML]="cell.content"></td>
</tr>
